@if (details$ | async; as details) {
  <app-warehouse-restock-details-attributes
    [comment]="details.comment"
    [createdAt]="details.createdAt"
    [approvedAt]="details.approvedAt"
    [rejectedAt]="details.rejectedAt"
    [orderId]="details.orderId"
    [orderNumber]="details.orderNumber"
    [id]="details.id"
    [number]="details.number"
    [personDignity]="details.personDignity"
    [personEmail]="details.personEmail"
    [personPhone]="details.personPhone"
    [restockedAt]="details.restockedAt"
    [shippingNumber]="details.shippingNumber"
    [status]="details.status"
    [type]="details.type" />

  <div class="mt-3">
    <app-details-view label="Produkty">
      @if (shouldShowProductAccordions(details.products)) {
        <div class="rounded-lg border border-gray-200 p-4">
          <p-accordion [multiple]="true">
            @for (
              product of details.products;
              track product.id;
              let index = $index
            ) {
              <p-accordion-panel [value]="index">
                <p-accordion-header>
                  <div class="flex items-center gap-2 text-sm text-gray-400">
                    <span>#{{ index + 1 }}</span>
                    <span>{{ product.productName }}</span>
                  </div>
                </p-accordion-header>

                <p-accordion-content>
                  <app-warehouse-restock-details-product-attributes
                    [createdAt]="product.createdAt"
                    [name]="product.productName"
                    [quantity]="product.quantity" />
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      } @else {
        <app-no-data />
      }
    </app-details-view>
  </div>

  @if (thumbnailsVisibility()) {
    @if (details.files) {
      <app-multimedia-galleria-thumbnails
        [files]="details.files"
        [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
    }
  }
} @else {
  <app-spinner-filled />
}
